import hybridAfterworkIdeas from './posts/hybrid-afterwork-ideas.js';
import multilingualTeamsSocializing from './posts/multilingual-teams-socializing.js';
import firstDaysNewJob from './posts/first-days-new-job.js';
import virtualCoffeeBreaks from './posts/virtual-coffee-breaks.js';
import includingIntrovertsTeamEvents from './posts/including-introverts-team-events.js';
import mandatoryFunBackfires from './posts/mandatory-fun-backfires.js';
import asyncSocializingTimeZones from './posts/async-socializing-time-zones.js';

//add new post modules here as they're written
const allPosts = [
    hybridAfterworkIdeas,
    multilingualTeamsSocializing,
    firstDaysNewJob,
    virtualCoffeeBreaks,
    includingIntrovertsTeamEvents,
    mandatoryFunBackfires,
    asyncSocializingTimeZones
];

//newest first
export const blogPosts = [...allPosts].sort(
    (a, b) => new Date(b.publishedDate) - new Date(a.publishedDate)
);

export const getPostBySlug = (slug) => blogPosts.find((post) => post.slug === slug);
